import React, { useEffect, useState } from 'react'
import { Button } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import LinearProgress from '@material-ui/core/LinearProgress';

import VismaService from "../../services/visma";
import ClientsService from "../../services/clients";

export default function SyncClients(props) {
    let [customers, setCustomers] = useState([]);
    let [clients, setClients] = useState([]);
    let [notInVismaClients, setNotInVismaClients] = useState([]);
    let [loading, setLoading] = useState(true);

    useEffect(() => {
        getCustomers()

    }, [])

    let getCustomers = () => {
        VismaService.getCustomers()
            .then(
                result => {
                    setCustomers(result.Data);
                    getClients();
                },
                error => { })
    }

    let getClients = () => {
        ClientsService.get()
            .then(
                result => { setClients(result); setLoading(false) },
                error => { setLoading(false) })
    }

    //compare
    useEffect(() => {
        if (clients.length > 0) {
            //find visma customers not in the app
            let tempCustomers = Object.assign([], customers);
            tempCustomers.forEach(customers => {
                let found = clients.find(client => { return client.clientnumber === customers.CustomerNumber });
                if (found) {
                    customers.Status = 1;
                } else {
                    customers.Status = 0;
                }
            });


            //find customers not in visma
            let notInVisma = [];
            clients.forEach(client => {
                let found = tempCustomers.find(tempCustomer => { return client.clientnumber === tempCustomer.CustomerNumber });
                if (!found) {
                    client.Status = 0;
                    notInVisma.push(client);
                }
            });
            setNotInVismaClients(notInVisma);
            setCustomers(tempCustomers);
        }
    }, [clients])

    let importClients = async () => {
        setLoading(true);
        let tempCustomers = Object.assign([], customers);
        for(let v = 0; v < tempCustomers.length;v++){
            if (tempCustomers[v].Status === 0) {
                let client = {};
                client.active = true;
                client.name = tempCustomers[v].Name;
                client.clientnumber = tempCustomers[v].CustomerNumber;
                client.contactperson = tempCustomers[v].ContactPersonName;
                client.email = tempCustomers[v].EmailAddress;
                client.mobile = tempCustomers[v].MobilePhone;
                client.phone = tempCustomers[v].Telephone;
                client.address = tempCustomers[v].InvoiceAddress1;
                client.pobox = tempCustomers[v].InvoicePostalCode;
                client.town = tempCustomers[v].InvoiceCity;

                let result = await ClientsService.save(client);
                if (result) {
                    tempCustomers[v].Status = 2;
                }

            }
        }

        setCustomers(tempCustomers);
        setLoading(false);
    }

    let exportClients = async () => {
        setLoading(true);
        let tempVismaClients = Object.assign([], notInVismaClients);
        let incompleteMessage = '';
        for(let v = 0; v < tempVismaClients.length;v++){
            if (!tempVismaClients[v].pobox || !tempVismaClients[v].town) {
                incompleteMessage += tempVismaClients[v].name + ', ';
            } else {
                let result = await VismaService.createCustomerInVisma(tempVismaClients[v]);
                if (result) {
                    tempVismaClients[v].Status = 2;
                }
            }
        }
       
        if (incompleteMessage.length > 0) {
            props.handleMessage({ title: 'Postcode en/of plaats ontbreekt bij '+ incompleteMessage });
        }
        setNotInVismaClients(tempVismaClients);
        setLoading(false);
    }

    let getStatus = (status) => {
        switch (status) {
            case 0:
                return <span style={{ color: 'red' }}>ONTBREEKT</span>;
            case 1:
                return <span style={{ color: 'black' }}>OK</span>;
            case 2:
                return <span style={{ color: 'green' }}>BIJGEWERKT</span>;
            default:
                return <span style={{ color: 'orange' }}>ONBEKEND</span>;
        }
    }

    return (
        <Paper >
            {loading && <LinearProgress color="secondary" />}
            <h3 className="padding">Klanten uit de Werkbon App die niet in VISMA staan</h3>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Nummer</TableCell>
                        <TableCell>Naam</TableCell>
                        <TableCell>Adres</TableCell>
                        <TableCell>Postcode</TableCell>
                        <TableCell>Plaats</TableCell>
                        <TableCell>Tel.nr.</TableCell>
                        <TableCell>Mobiel</TableCell>
                        <TableCell>Contactpersoon</TableCell>
                        <TableCell>Emailadres</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {notInVismaClients.map(row => (
                        <TableRow key={row._id}>
                            <TableCell >{getStatus(row.Status)} </TableCell>
                            <TableCell >{row.clientnumber} </TableCell>
                            <TableCell >{row.name}</TableCell>
                            <TableCell >{row.address}</TableCell>
                            <TableCell >{row.pobox}</TableCell>
                            <TableCell >{row.town}</TableCell>
                            <TableCell >{row.phone}</TableCell>
                            <TableCell >{row.mobile}</TableCell>
                            <TableCell >{row.contactperson}</TableCell>
                            <TableCell >{row.email}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button variant="contained" color="primary" onClick={() => { exportClients() }} style={{ width: '100%' }} disabled={loading}>Exporteer</Button>


            <h3 className="padding">Klanten uit VISMA</h3>
            <Table >
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Nummer</TableCell>
                        <TableCell>Naam</TableCell>
                        <TableCell>Adres</TableCell>
                        <TableCell>Postcode</TableCell>
                        <TableCell>Plaats</TableCell>
                        <TableCell>Tel.nr.</TableCell>
                        <TableCell>Mobiel</TableCell>
                        <TableCell>Contactpersoon</TableCell>
                        <TableCell>Emailadres</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {customers.map(row => (
                        <TableRow key={row.Id}>
                            <TableCell >{getStatus(row.Status)} </TableCell>
                            <TableCell >{row.CustomerNumber} </TableCell>
                            <TableCell >{row.Name}</TableCell>
                            <TableCell >{row.InvoiceAddress1}</TableCell>
                            <TableCell >{row.InvoicePostalCode}</TableCell>
                            <TableCell >{row.InvoiceCity}</TableCell>
                            <TableCell >{row.Telephone}</TableCell>
                            <TableCell >{row.MobilePhone}</TableCell>
                            <TableCell >{row.ContactPersonName}</TableCell>
                            <TableCell >{row.ContactPersonEmail}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button variant="contained" color="primary" onClick={() => { importClients() }} style={{ width: '100%' }} disabled={loading}>Importeer</Button>
        </Paper>
    )
}
